export const formatOrderStatus = (status, orderType) => {
  switch (status) {
    case 'ready':
      if (orderType == 'pick-up') {
        return 'Ready for Pick-Up';
      }
      if (orderType == 'dine-in') {
        return 'Ready for Dine-In';
      }
      return 'Ready';
    default:
      return status;
  }
};

export const formatOrderType = (orderType) => {
  let icon, text;
  switch (orderType) {
    case 'pick-up':
    case 'pickup':
      icon = 'hand-holding-box';
      text = 'Pickup';
      break;

    case 'delivery':
      icon = 'truck';
      text = 'Delivery';
      break;

    case 'dine-in':
    case 'dinein':
      icon = 'utensils';
      text = 'Dine-In';
      break;
  }

  return {
    icon: icon,
    text: text,
  };
};

export const getOrderStatusColor = (status) => {
  switch (status.toLowerCase()) {
    case 'cancelled':
      return 'red-500';

    case 'complete':
      return 'emerald-500';

    case 'ready':
      return 'amber-500';

    case 'processing':
      return 'pink-500';

    case 'received':
      return 'blue-500';

    default:
      return 'gray-500';
  }
};

export const getOrderStatusIcon = (status) => {
  switch (status.toLowerCase()) {
    case 'cancelled':
      return 'times';

    case 'complete':
      return 'check';

    case 'ready':
      return 'inbox-out';

    case 'processing':
      return 'sync';

    case 'received':
      return 'inbox-in';

    default:
      return '';
  }
};
